import React, { useEffect, useState } from 'react'
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

const LINE_COLORS = ['#44e5e7', '#386fa4', '#33C0A4', '#A8DCD9', '#ECA089']
const LEFT_YTICK_COLOR = '#FFE5FF'

export function formatNumber(number) {
  if (isNaN(number) || number === '' || number === undefined) {
    return '0'
  }
  return "$" +parseFloat(number).toFixed(4)
}

export function formatNumberScale(number, usd = false, decimals = 0) {
  if (isNaN(number) || number === '' || number === undefined) {
    return usd ? '$0.00' : '0'
  }
  const num = parseFloat(number)
  const fullNum = Math.floor(num).toLocaleString('fullwide', {
    useGrouping: false,
  })
  const wholeNumberLength = fullNum.length

  if (wholeNumberLength >= 19) return usd ? '> $1000 Q' : '> 1000 Q'
  if (wholeNumberLength >= 16)
    return (usd ? '$' : '') + (num / Math.pow(10, 15)).toFixed(decimals) + ' Q'
  if (wholeNumberLength >= 13)
    return (usd ? '$' : '') + (num / Math.pow(10, 12)).toFixed(decimals) + ' T'
  if (wholeNumberLength >= 10)
    return (usd ? '$' : '') + (num / Math.pow(10, 9)).toFixed(decimals) + ' B'
  if (wholeNumberLength >= 7)
    return (usd ? '$' : '') + (num / Math.pow(10, 6)).toFixed(decimals) + ' M'
  if (wholeNumberLength >= 4)
    return (usd ? '$' : '') + (num / Math.pow(10, 3)).toFixed(decimals) + ' K'

  if (num < 0.0001 && num > 0) {
    return usd ? '< $0.0001' : '< 0.0001'
  }

  return (usd ? '$' : '') + num.toFixed(decimals)
}



const MultiLineChartAum = ({
  data,
  xDataKey,
  yDataKeys,
  legend,
  format,
}) => {
  const [chartData, setChartData] = useState([])

  useEffect(() => {
    if (!data.length) {
      return
    }

    setChartData(data)
  }, [data])
 

  return (
    <ResponsiveContainer width="95%" height={400}>
      <LineChart data={chartData} debounce={1}>
        <CartesianGrid
          horizontal={true}
          vertical={true}
          opacity={0.2}
          strokeDasharray="8"
        />
        <XAxis dataKey={xDataKey} />
        <YAxis
          fontSize="14px"
          yAxisId="left"
          tick={{ stroke: LEFT_YTICK_COLOR }}
          tickLine={{ stroke: LEFT_YTICK_COLOR }}
          tickFormatter={
            format === false
              ? (data) => {
                  return data
                }
              : formatNumberScale
          }
          domain={['auto', 'auto']}
        />
        {/* <YAxis
          yAxisId="right"
          orientation="right"
          tick={{ stroke: RIGHT_YTICK_COLOR }}
          tickLine={{ stroke: RIGHT_YTICK_COLOR }}
        /> */}
        <Legend />
        {yDataKeys.map((key, index) => (
          <Line
            key={key}
            type="monotone"
            dataKey={key}
            stroke={LINE_COLORS[index]}
            yAxisId={'left'}
            strokeWidth={2}
            dot={false}
            name={legend[index]}
          />
        ))}
        <Tooltip
          contentStyle={{
            backgroundColor: '#05113b',
            border: 'none',
            borderRadius: '12px',
            fontSize: '12px',
          }}
          formatter={format === false ? (data) => data : formatNumberScale}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}

export default MultiLineChartAum
